import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './BackgroundColorLayer.css';

const BackgroundColorLayer = ({ color: backgroundColor }) => (
  <div style={{ backgroundColor }} className={s.backgroundColorLayer} />
);

export default withStyles(s)(BackgroundColorLayer);
